import { app } from '../../../../app';
import { Controller } from './edit-note.controller';

app.component('userPublicNotesEdit', {
	bindings: {
		note:'<',
		notes:'<',
	},
    controller: Controller,
    templateUrl: require('./edit-note.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/notes/edit/edit-note.component.js